import retrieveLocalData from "./retrieveLocalData";

export default () =>
  retrieveLocalData("transactionLoadInputs");
